/* 
 * TRUNCATR
 * truncation as progressive enhancement
 * =====================================
 *
 * Given an element containing text, truncatr will create a full text element and
 * an excerpt element. You can then show one and hide the other as you'd like.
 * Because we're doing truncation on the client and not the server, browsers
 * that haven't loaded the JS yet will see the full text.
 */ 

; define('core/ef_plugins/truncatr',["jquery"], function (jQuery) {
    (function ($, window, document, undefined) {

        var pluginName = 'truncatr',
            defaults = {
                maxLength: 85, // Max length of excerpt, in chars. Breaks at word.
                fullWrapper: '<div class="truncatr-full" />', // We're using "quick-closing" tags: http://api.jquery.com/jQuery/#jQuery2
                excerptWrapper: '<div class="truncatr-excerpt" />',
                ending: '...', // Text to be added to the end of the excerpt.
            };

        // ReSharper disable once InconsistentNaming
        function Truncatr(element, options) {
            this.element = element;
            this.$element = $(element);

            this.metadata = this.$element.data('truncatr-options');
            this.options = $.extend({}, defaults, options, this.metadata);
            this._defaults = defaults;

            this._name = pluginName;
            this.init();
        }

        Truncatr.prototype = {
            init: function () {
                var plugin = this,
                    $el = plugin.$element,
                    $children;
                // Temporarily detach children so we don't overwrite them.
                $children = $el.children().not('br, p').detach();
                // Clean up HTML.
                plugin._wrapTextWithP($el);
                plugin._sanitize($el);
                // Create the excerpt and full text objects.
                if ($el.text().length <= plugin.options.maxLength) {
                    // Text isn't long enough for an excerpt. Abort!
                    plugin.destroy();
                    return;
                }
                plugin.$excerpt = $(plugin.options.excerptWrapper).append(plugin._createExcerpt($el));
                plugin.$full = $(plugin.options.fullWrapper).append($el.children());
                // Clear out the element. Append the excerpt and full text. Re-attach the children.
                $el.html('').append(plugin.$full, plugin.$excerpt, $children);
            },

            truncate: function (origText, max, ending) {
                var newText = '',
                    separator = ' ',
                    punctuation = [',', '.', '!', '?'],
                    indexOfLastSeparator = -1;
                if (max === 0) {
                    return '';
                }
                if (origText.length <= max) {
                    // Text is already under max and doesn't need to be truncated.
                    return origText;
                }
                newText = origText.substring(0, max - ending.length);
                indexOfLastSeparator = newText.lastIndexOf(separator);
                if (indexOfLastSeparator !== -1) {
                    newText = newText.slice(0, indexOfLastSeparator);
                    // If there are no spaces, just cut the text off at the max.
                }
                // If new text ends with punctuation, remove it.
                for (var i = 0; i < punctuation.length; i++) {
                    if (newText.charAt(newText.length - 1) === punctuation[i]) {
                        newText = newText.substring(0, newText.length - 1);
                        break;
                    }
                }
                newText += ending;
                return newText;
            },

            _createExcerpt: function ($el) {
                var plugin = this,
                    origText = $el.find('p').first().text(),
                    $excerpt = $('<p />');
                // We're grabbing just text from the first paragraph. If that
                // paragraph's text is under the max, we'll show the entire
                // paragraph in the excerpt, but not subsequent paragraphs.
                return $excerpt.text(plugin.truncate(origText, plugin.options.maxLength, plugin.options.ending));
            },

            _sanitize: function ($el) {
                $el.find('p').each(function () {
                    var $this = $(this),
                        text = $.trim($this.html());
                    if (text === '' || text === '&nbsp;') { // Sigh.
                        $this.remove();
                    }
                });
            },

            _wrapTextWithP: function ($el) {
                // Wrap the text nodes inside $elem with p so that we can maniuplate them.
                if ($el.children().length === 0) {
                    $el.wrapInner('<p />');
                    return true;
                }

                if ($el.children().not('br').length === 0) {
                    // Wrap each text node with paragraph tags, then remove the <br> tags.
                    // Based on an example from http://api.jquery.com/contents/
                    $el.contents().filter(function () { return this.nodeType === 3; })
                        .wrap('<p />').end()
                        .filter('br').remove();
                    return true;
                }
                return false;
            },

            destroy: function () {
                var plugin = this;
                // remove the data
                plugin.$element.removeData('plugin_' + pluginName);
            }

        };

        // Turn this into a jquery plugin & prevent multiple instantiations
        $.fn[pluginName] = function (options) {
            return this.each(function () {
                if (!$.data(this, 'plugin_' + pluginName)) {
                    $.data(this, 'plugin_' + pluginName,
                        new Truncatr(this, options));
                }
            });
        }

    })(jQuery, window, document);
});
